/* Modern collection facets behaviour — added by Claude for dxbanimal (draft theme only).
   Vanilla JS, self-contained. Handles: mobile filter drawer, auto-apply, dual price
   slider, a mobile "Filter" button injected into the toolbar, and a sort override that
   preserves ALL active filter params (Ella's AJAX sort collapses repeated query keys,
   which would otherwise drop multi-value filters). */
(function () {
  'use strict';
  var root = document.documentElement;
  var OPEN = 'halo-filters-open';

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var form = qs('#HaloFacetForm');
  if (!form) return;

  var facets = qs('#HaloFacets');
  var mq = window.matchMedia('(max-width: 1199px)');
  function isMobile() { return mq.matches; }

  function openDrawer() { root.classList.add(OPEN); }
  function closeDrawer() { root.classList.remove(OPEN); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-halo-filter-toggle]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-halo-facets-close]') || e.target.closest('[data-halo-facets-overlay]')) { e.preventDefault(); closeDrawer(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && root.classList.contains(OPEN)) closeDrawer();
  });

  function cleanEmptyNumbers() {
    qsa('input[type="number"]', form).forEach(function (inp) {
      if (inp.value === '' || inp.value == null) { inp.disabled = true; }
    });
  }
  form.addEventListener('submit', cleanEmptyNumbers);

  function submitForm() {
    cleanEmptyNumbers();
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
  }

  // Auto-apply on desktop; on mobile the user taps Apply to avoid reload churn.
  form.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('halo-facet__checkbox') && !isMobile()) submitForm();
  });

  qsa('[data-halo-price-min], [data-halo-price-max]', form).forEach(function (inp) {
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); submitForm(); } });
    inp.addEventListener('change', function () { if (!isMobile()) submitForm(); });
  });

  // Dual-handle price slider
  qsa('[data-halo-price]').forEach(function (wrap) {
    var minR = qs('[data-halo-slider-min]', wrap);
    var maxR = qs('[data-halo-slider-max]', wrap);
    var rangeEl = qs('[data-halo-slider-range]', wrap);
    var minN = qs('[data-halo-price-min]', wrap);
    var maxN = qs('[data-halo-price-max]', wrap);
    var max = parseFloat(wrap.getAttribute('data-max')) || 0;
    if (!minR || !maxR) return;

    function paint() {
      var a = parseFloat(minR.value), b = parseFloat(maxR.value);
      if (isNaN(a)) a = 0; if (isNaN(b)) b = max;
      if (a > b) { var t = a; a = b; b = t; }
      var lp = max ? (a / max) * 100 : 0;
      var rp = max ? (b / max) * 100 : 100;
      if (rangeEl) { rangeEl.style.left = lp + '%'; rangeEl.style.right = (100 - rp) + '%'; }
    }
    function syncFromSlider() {
      var a = parseFloat(minR.value), b = parseFloat(maxR.value);
      if (a > b) { var t = a; a = b; b = t; minR.value = a; maxR.value = b; }
      if (minN) minN.value = (a <= 0) ? '' : a;
      if (maxN) maxN.value = (b >= max) ? '' : b;
      paint();
    }
    minR.addEventListener('input', syncFromSlider);
    maxR.addEventListener('input', syncFromSlider);
    minR.addEventListener('change', function () { if (!isMobile()) submitForm(); });
    maxR.addEventListener('change', function () { if (!isMobile()) submitForm(); });
    if (minN) minN.addEventListener('input', function () { if (minN.value !== '') minR.value = minN.value; paint(); });
    if (maxN) maxN.addEventListener('input', function () { if (maxN.value !== '') maxR.value = maxN.value; paint(); });
    paint();
  });

  // Inject a mobile "Filter" button into the collection toolbar (progressive enhancement).
  (function injectToggle() {
    if (qs('[data-halo-filter-toggle]')) return;
    var toolbarLeft = qs('.toolbar .column-left') || qs('.toolbar');
    if (!toolbarLeft) return;
    var labelEl = qs('.halo-facets__head-title');
    var label = labelEl ? labelEl.textContent.trim() : 'Filter';
    var count = qsa('#HaloFacets .halo-facets__pills > li').length;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'halo-filter-toggle';
    btn.setAttribute('data-halo-filter-toggle', '');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg><span>' + label + '</span>' + (count ? '<span class="halo-filter-toggle__count">' + count + '</span>' : '');
    toolbarLeft.insertBefore(btn, toolbarLeft.firstChild);
  })();

  // Preserve active filters when the (Ella) sort dropdown is used. Capture phase so we
  // run before Ella's delegated handler, then stop it and do a clean full-page reload.
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.filters-toolbar__sortby [data-href]');
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', el.getAttribute('data-href'));
    params.delete('page');
    var q = params.toString();
    window.location.href = window.location.pathname + (q ? '?' + q : '');
  }, true);
})();
